export class TilmeldingFilter {
    public skoleaar: number;
    public search: string;

    constructor() {
        this.skoleaar = new Date().getFullYear();
    }
}  


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/TilmeldingFilter.ts